import { ToFromDetails } from './ToFromDetails';

export { ToFromDetails };
